import { AlertCircle, Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const NoAccessPage = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{ height: 'calc(-64px + 100vh)' }}
      className='flex items-center justify-center overflow-hidden bg-gray-50 px-4'
    >
      <div className='w-full max-w-md rounded-lg bg-white p-8 text-center shadow-lg'>
        <div className='mb-6 flex justify-center'>
          <div className='rounded-full bg-red-100 p-4'>
            <Lock className='h-12 w-12 text-red-600' />
          </div>
        </div>

        <h1 className='mb-3 text-2xl font-bold text-gray-900'>Access Denied</h1>

        <div className='mb-6 flex items-start gap-3 rounded-lg border border-yellow-200 bg-yellow-50 p-4'>
          <AlertCircle className='mt-0.5 h-5 w-5 flex-shrink-0 text-yellow-600' />
          <p className='text-left text-sm text-gray-700'>
            You do not have permission to access this page. Please contact your
            administrator if you believe this is an error.
          </p>
        </div>

        <button
          onClick={() => navigate('/analytics')}
          className='w-full rounded-lg bg-blue-600 px-4 py-2.5 font-medium text-white transition-colors hover:bg-blue-700'
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default NoAccessPage;
